import { Component, Inject, HostListener, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { LoginService } from "../Service/Login.Service";
import { LoginModel, GeneralBookingModel, FileSearch, UserData } from "../../model/index"
import { Title } from '@angular/platform-browser';
import { SecurityService } from '../../Security/security.service';
import { CurrencyDetails } from "../../model/utilities/currencydetails";
import { OtpModel } from "../../Model/ServicePayment/OtpModel";
declare var require: any;

@Component({
    selector: 'MentisSoft-Login',
    template: require('../Template/Login.template.html'),
    styles: [require('../Template/Login.css')],
    providers: [CurrencyDetails]
})

export class LoginComponent implements AfterViewInit {

    constructor(@Inject(SecurityService) private _SecurityService: SecurityService, private router: Router, private route: ActivatedRoute,
        private _LoginService: LoginService, private _titleService: Title,
        @Inject(CurrencyDetails) private _CurrencyDetails: CurrencyDetails) {
    }

    @HostListener('document:keyup', ['$event'])
    onKeyUp(ev) {
        if (ev.keyCode == 13) {
            this.logon();
        }
    }
    imag: string = "";
    HospitalName: boolean = true;
    SecureValue: string = "";
    
    Civilplace: string = "Civil ID/Patient ID";
    OTPNAME: string = "Password";
    IsopenTermConditions: boolean = false;
    TermsChecked: boolean = false;
    ngAfterViewInit(): void {
        $('#overlay').hide();
        this.getLogo(); 
        localStorage.setItem("KioskORPortal", this.KioskORPortal);
        
        if (this._SecurityService.errorMessage != "") {
            this.errMsg = this._SecurityService.errorMessage;
        }
        else {
            this.errMsg = "";
        }
        this.Hospital = localStorage.getItem("HospitalName");
    }
    ngOnInit() {
        this.getLogo();
        this.getcprno();
        this.Hospital = localStorage.getItem("HospitalName");
        if (localStorage.getItem("HospitalName") == "BSH") {
            this.Civilplace = "CPR No/Patient ID";
        }

    }
    getLogo() {
        var locIsHos;
        this._LoginService.GetLogo(this.loginInfo)
            .subscribe(function (s) {
                if (s != null) {
                    this.imag = s.ImageByte;
                    this.SecureValue = s.SecureValue;
                    this.CPRNOlength = s.CPRNOlength;
                    locIsHos = s.HospitalName;
                    localStorage.setItem("HospitalName", locIsHos);
                    this.Hospital = locIsHos
                    localStorage.setItem("SecureValue", this.SecureValue);
                    localStorage.setItem("CPRNOlength", this.CPRNOlength);
                    if (s.HospitalName == "BSH")
                        this.HospitalName = true;
                    else
                        this.HospitalName = false;
                }
            });
    }

    loginInfo: LoginModel = new LoginModel();
    isValidInfo: boolean = true;
    loading = false;
    errMsg: string = "";
    abcvalue: string = "";
    InvalidAttempts: number = 0;
    Hospital: string = "";
    fileSearch: FileSearch = new FileSearch();
    fileSearchRes: FileSearch[] = [];
    appointmentPatientId: string = "";
    appointmentCivilId: string = "";
    selectedPatientId: string = "";
    HiddenMobileNumber: string = "";
    RadioPatientId: string = "";
    CPRNOlength: string = localStorage.getItem("CPRNOlength");   
    SelecterrMsg: string = "";
    IsselectPatientSearch: boolean = false;
    IsPatientcountone: boolean = true;
    CivilMsg: string = "";
    CvilIdNoRed: boolean = false;
    TimeCounter: string = "";
    IsOTPSent: boolean = false;
    otpModel: OtpModel = new OtpModel();
    IsOtpVerifiedSucess: boolean = false;
    OtpNumber: string = "";
    IsSearchBtnClicked: boolean = false;
    IsSendOTPBtnDisabled: boolean = true;
    IsPatientDetailsSelected: boolean = false;
    newCPRNOlength: string = "";  
    KioskORPortal: string = "";
    //IsForgotEnable: boolean = false;
    IsForgotButton: boolean = true;
    Istermcheck: boolean = true;
    logon() {
        this.errMsg = "";
        this.SelecterrMsg = "";
        this._titleService.setTitle("Login");
        this.loading = true;
        var locIsAdminUser;
        this.loginInfo.SecureValue = localStorage.getItem("SecureValue");
        if (this.selectedPatientId != "" && this.selectedPatientId != null && this.selectedPatientId != undefined) {
            this.loginInfo.username = this.selectedPatientId;
            this.selectedPatientId = "";
        }
        if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
            if (this.TermsChecked == true) {
                this.Istermcheck = true;
            }
            else {
                this.Istermcheck = false;
            }
    }

        if (this.loginInfo != null && (this.loginInfo.username != null || this.loginInfo.username != "" || this.loginInfo.username != undefined) &&
            (this.loginInfo.password != null || this.loginInfo.password != "" || this.loginInfo.password != undefined) && this.Istermcheck==true) {

            this._LoginService.validCredentials(this.loginInfo)
                .subscribe(
                    p => {
                        this.loading = false;
                        if (p.ErrorMessage != null) {
                            this.errMsg = p.ErrorMessage;
                        }

                        else if (p.IsValid && p.ErrorMessage == null) {
                            this._LoginService.GetCurrencyDetails(this.loginInfo)
                                .subscribe(
                                    s => {
                                        localStorage.setItem("CurrencySymbol", s);
                                    });

                            this.InvalidAttempts = 0;
                            this._SecurityService.id = p.pid;
                            this._SecurityService.pid = p.pid;
                            this._SecurityService.userId = this.loginInfo.username;
                            this._SecurityService.IsAdminUser = p.IsAdminUser;
                            this._SecurityService.RoleId = p.RoleId;
                            locIsAdminUser = this._SecurityService.IsAdminUser;

                            this._SecurityService.authentication = "TESTAUTH";
                            if (p.RoleId == 2)
                                this.router.navigate(["/SearchScreen"]);
                            else {
                                if (p.ISUserLogin == "0")
                                    this.router.navigate(["/Dashboard"]);
                                else
                                    this.router.navigate(["/ChangePassword"]);
                            }
                            this.errMsg = "Succes.";
                            localStorage.setItem("patientName", this._SecurityService.userId);
                            localStorage.setItem("RoleId", this._SecurityService.RoleId.toString());
                            localStorage.setItem("ISAdmin", locIsAdminUser.toString());

                        }
                        else {
                            this.errMsg = "Invalid Username or Password/OTP!";
                        }
                    });
        }
        else {
            this.loading = false;
            if (localStorage.getItem("HospitalName").toUpperCase() == "BSH") {
                if (this.loginInfo.username == null && this.loginInfo.password == null) {
                    this.errMsg = "Your user name and password is required.";
                }
                else if (this.loginInfo.username == null || this.loginInfo.password == null){
                    if (this.loginInfo.username == null || this.loginInfo.password == null) {
                        this.errMsg = "Your user name is required";
                    }
                    else {
                        this.errMsg = "Your password is required.";
                    }
                    
                }
                else {
                    if (this.TermsChecked == false)
                        this.errMsg = "Please select Terms and conditions option";
                }
                
            }
            else {
                if (this.loginInfo.username == null && this.loginInfo.password == null) {
                    this.errMsg = "Your user name and password is required.";
                }
                else {
                    if (this.loginInfo.username == null || this.loginInfo.password == null) {
                        this.errMsg = "Your user name is required";
                    }
                    else {
                        this.errMsg = "Your password is required.";
                    }
                }
            }
           
        }
    }

    Registration(event) {
        this.router.navigate(["/Registration"]);
    }

    logSignUp(event) {
        this.router.navigate(["/SignUp"]);
    }

    GuestAppointment() {
        this.router.navigate(["/GuestAppointment"]);
    }

    logForgotPassword(event) {
        this.router.navigate(["/ForgotPassword"]);
    }

    ServicePayment(event) {
        this.router.navigate(["/SearchServicePayment"]);
    }

    radioClick(data: FileSearch) {
        this.RadioPatientId = "";
        this.errMsg = "";
        this.IsOTPSent = false;
        this.IsOtpVerifiedSucess = false;
        this.OtpNumber = "";
        this.IsSearchBtnClicked = true;
        this.IsSendOTPBtnDisabled = false;
        this.RadioPatientId = data.PatientId;
        this.selectedPatientId = data.PatientId;
        this.HiddenMobileNumber = data.DummyMobileNumber;
        this.LoadOtpModel(data);
        this.loginInfo.password = "";
    }
    LoadOtpModel(data: FileSearch) {
        this.otpModel.CIVILID = data.CPRNO;
        this.otpModel.MOBILENO = data.MobileNumber;
        this.otpModel.PATIENTID = data.PatientId;
        this.otpModel.FIRST_NAME = data.FIRST_NAME;
        this.otpModel.MIDDLE_NAME = data.MIDDLE_NAME;
        this.otpModel.LAST_NAME = data.LAST_NAME;
        this.otpModel.REGISTERCOUNT = data.REGISTERCOUNT;
        this.otpModel.REGISTERNO = data.REGISTERNO;
    }
    onSearchChange(searchValue: string): void {
        this.IsSendOTPBtnDisabled = true;
        this.IsOTPSent = false;
        this.fileSearchRes = null;
        //this.getcprno();
        this.CPRNOlength = localStorage.getItem("CPRNOlength");
        if (this.CPRNOlength != null && this.CPRNOlength != undefined && this.CPRNOlength!="")
            this.CPRNOlength = this.CPRNOlength;
        else
            this.CPRNOlength = this.newCPRNOlength;
        if (searchValue.length == Number(this.CPRNOlength)) {
            this.Search();
            this.CivilMsg = "";
        }
    }

    SendOtpToMobileNumber() {
        this.IsSendOTPBtnDisabled = true;
        this.loginInfo.password = "";
        this.errMsg = "";
        if (this.RadioPatientId != "" || this.RadioPatientId != null || this.RadioPatientId != undefined) {
            this.IsPatientDetailsSelected = false;
            var userData: UserData = new UserData(this._SecurityService.pid, this._SecurityService.authentication, this._SecurityService.pid, this._SecurityService.IsAdminUser);
            this._LoginService.SentOtp(this.otpModel, userData)
                .subscribe(
                    p => {
                        this.otpModel = p;
                        this.IsOTPSent = true;
                        this.IsOtpVerifiedSucess = false;
                        this.IsSearchBtnClicked = false;
                        this.IsSendOTPBtnDisabled = true;
                        this.OtpNumber = "";
                    }, err => {
                        console.log("Error while getting data...");
                    });
        } else {
            this.IsPatientDetailsSelected = true;
        }
    }
    getcprno() {
        this._LoginService.GetLogo(this.loginInfo)
            .subscribe(
                p => {
                    this.newCPRNOlength = p.CPRNOlength;
                }, err => {
                    console.log("Error while getting data...");
                });
    }
    Search() {
        this.RadioPatientId = "";
        this.errMsg = "";
        this.appointmentPatientId = this.loginInfo.username;
        this.IsOTPSent = false;
        this.IsOtpVerifiedSucess = false;
        this.OtpNumber = "";
        this.IsSearchBtnClicked = false;
        this.IsSendOTPBtnDisabled = true;
        this.fileSearch.PatientId = "";
        this.fileSearch.CPRNO = "";
        this.fileSearchRes = [];
        this.fileSearch = new FileSearch();
        this.selectedPatientId = "";
       // this.getcprno();
        this.CPRNOlength = localStorage.getItem("CPRNOlength");
        if (this.CPRNOlength != null && this.CPRNOlength != undefined && this.CPRNOlength != "")
            this.CPRNOlength = this.CPRNOlength;
        else
            this.CPRNOlength = this.newCPRNOlength;

        if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)) {
            this.SelecterrMsg = "Please enter the Civil ID/Patient ID.";
            this.IsselectPatientSearch = true;
            this.CvilIdNoRed = false;
        }
        if (this.appointmentPatientId.length > Number(this.CPRNOlength)) {
            this.SelecterrMsg = "";
            this.CivilMsg = "Civil ID/CPR No is required, length should be " + this.CPRNOlength;
            this.CvilIdNoRed = true;
        }
        else if ((this.appointmentPatientId != "" || this.appointmentPatientId != undefined || this.appointmentPatientId != null) && this.appointmentPatientId.length <= Number(this.CPRNOlength)) {
            this.SelecterrMsg = "";
            this.IsselectPatientSearch = false;
            if (this.appointmentPatientId.length > Number(this.CPRNOlength))
                this.CvilIdNoRed = true;
            else {
                this.CvilIdNoRed = false;
                this.SelecterrMsg = "";

                if (this.appointmentPatientId.length == Number(this.CPRNOlength)) {
                    this.IsSearchBtnClicked = false;
                    this.IsSendOTPBtnDisabled = true;
                    this.fileSearch.CPRNO = this.appointmentPatientId;
                    this.fileSearch.PatientId = "";
                } else {
                    this.IsSearchBtnClicked = false;
                    this.IsSendOTPBtnDisabled = true;
                    this.fileSearch.CPRNO = "";
                    this.fileSearch.PatientId = this.appointmentPatientId;
                }

                this._LoginService.GetLoginSearchDetails(this.fileSearch)
                    .subscribe(
                        p => {
                            if (p != null) {
                                this.IsSearchBtnClicked = false;
                                this.IsSendOTPBtnDisabled = true;
                                if (!p.IsValidPatient) {
                                    if (localStorage.getItem("HospitalName").toUpperCase() == "HADI") {
                                        this.SelecterrMsg = "Search Patient file not exist, please contact 1828282 for more info. ";
                                    }
                                    else {
                                    this.SelecterrMsg = "Search Patient file not exist. ";
                                    }
                                    this.IsselectPatientSearch = true;
                                }
                                else {
                                    if (p.fileSearch.length > 0) {
                                        this.fileSearchRes = p.fileSearch;
                                        this.selectedPatientId = p.fileSearch[0].PatientId
                                        this.HiddenMobileNumber = p.fileSearch[0].DummyMobileNumber;
                                        if (p.fileSearch.length == 1) {
                                            this.LoadOtpModel(p.fileSearch[0]);
                                            this.IsPatientcountone = true;
                                            this.IsSearchBtnClicked = true;
                                            this.IsSendOTPBtnDisabled = false;
                                        }
                                        else {
                                            this.IsSearchBtnClicked = false;
                                            this.IsSendOTPBtnDisabled = true;
                                            this.IsPatientcountone = false;
                                        }
                                        this.SelecterrMsg = "";
                                        this.IsselectPatientSearch = false;
                                    }
                                }

                            } else {
                                this.SelecterrMsg = "Search Patient file not exist, please contact 1828282 for more info. ";
                            }
                        },
                        err => {
                            console.log("Error while validating...");
                        }

                    );
            }
        }
    }

    ForgotPassword() {
       // this.Search();
        if ((this.appointmentPatientId == "" || this.appointmentPatientId == undefined || this.appointmentPatientId == null)) {
            this.SelecterrMsg = "Please enter the Civil ID/Patient ID.";
            this.IsselectPatientSearch = true;
            this.CvilIdNoRed = false;
        }
        else {
            // this.IsForgotEnable = true;
            this.OTPNAME = "Enter the OTP";
            this.IsForgotButton = false;
            this.SendOtpToMobileNumber();
        }
    }

    openTermsCondition() {
        this.IsopenTermConditions = true
    }
    ClosePopup() {
        this.IsopenTermConditions = false;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/login/Component/Login.Component.ts